import React, { useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import HookForm from '../../../../components/HookForm/HookForm';
import Button from '../../../../components/Button/Button';
import Loader from '../../../../components/Loader/Loader';
import LoaderInline from '../../../../components/Loader/LoaderInline';
import formStyles from '../../../../components/Form/form.module.css';

import SellerBlock from './SellerBlock';
import { buildCarInfoInputs } from '../carInfoInputs';

import createCar from '../../../../api/cars/createCar';
import createConsignment from '../../../../api/cars/createConsignment';
import getDcRequisites from '../../../../api/cars/getDcRequisites';
import ensureContainer from '../../../../api/cars/ensureContainer';
import getItems from '../../../../api/cars/getItems';

import alert from '../../../../helpers/alert';
import extractErrorMessage from '../../../../utils/extractErrorMessage';
import { CAR_ORIGIN_TYPES } from '../../../../constants/carOrigin';
import { textStyles } from '../../../../constants/textStyles';
import {
  REQUISITES_FIELDS,
  REQUISITES_INPUTS,
  SELLER_REQUISITES_INPUTS,
  cleanBank,
  requisitesTitle,
  sellerFio,
} from './requisitesInputs';

const carGrid = { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr 1fr 1fr', alignItems: 'flex-end' };
const reqGrid = { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr 1fr' };
const reqOverlay = {
  position: 'absolute',
  inset: 0,
  zIndex: 5,
  background: 'rgba(255, 255, 255, 0.7)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

/**
 * ÐÐ¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð±/Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ â Ð¾Ð´Ð¸Ð½ ÑÐºÑÐ°Ð½ Ð±ÐµÐ· ÑÐ°Ð³Ð¾Ð²:
 * Ð´Ð°Ð½Ð½ÑÐµ Ð¢Ð¡, Ð¿ÑÐ¾Ð´Ð°Ð²ÐµÑ (ÐºÐ»Ð¸ÐµÐ½Ñ CRM), ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐÐ¦ Ð¸ ÑÑÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°.
 * ÐÐ¾ÑÐ»Ðµ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÑÐ°Ð·Ñ Ð¿ÐµÑÐµÑÐ¾Ð´Ð¸Ñ Ðº ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ñ ÑÐ´ÐµÐ»ÐºÐ¸.
 */
const ConsignmentCreate = ({ originInput }) => {
  const navigate = useNavigate();

  const carFormRef = useRef(null);
  const reqFormRef = useRef(null);
  const sellerReqFormRef = useRef(null);
  const sellerRef = useRef(null);

  const [containerId, setContainerId] = useState(null);
  const [seller, setSeller] = useState(null);
  const [sellerError, setSellerError] = useState('');
  const [saving, setSaving] = useState(false);
  const [loadingRequisites, setLoadingRequisites] = useState(false);
  // ÐÑÐº Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð¸Ð» ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ Ð¿Ð¾ÑÑÐµÐ´Ð½Ð¸ÐºÐ° ÐºÐ¾Ð½ÑÑÑÐ° Ð²Ð¼ÐµÑÑÐ¾ ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÐ¾Ð² Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ ÐÐ¦
  const [viaIntermediary, setViaIntermediary] = useState(false);
  const [carId, setCarId] = useState(null);

  // Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ Ð±ÐµÑÑÐ¼ ÑÐ¾Ð²Ð½Ð¾ Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ ÐÐ¦ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ â Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÑÐµÐ¼
  // Ð¿Ð¾ ÐÐ¦ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°, Ð¿Ð¾ÐºÐ° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ°Ð¼ Ð½Ðµ Ð²ÑÐ±ÑÐ°Ð» ÐÐ¦.
  const handleDcChange = async (selected) => {
    const list = Array.isArray(selected) ? selected : [selected];
    const dcId = list[list.length - 1]?.value;
    if (!dcId) return;

    setLoadingRequisites(true);
    const res = await getDcRequisites(dcId).catch(() => null);
    const requisites = res?.data || {};
    setViaIntermediary(!!requisites.viaIntermediary);
    Object.entries(REQUISITES_FIELDS).forEach(([field, key]) =>
      reqFormRef.current?.setValue(field, requisites?.[key] ?? '')
    );
    setLoadingRequisites(false);
  };

  // ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð²Ð¸ÑÑÑ Ð½Ð° ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐµ (Ð¿Ð°ÑÐ° Ð¼Ð°ÑÐºÐ°+Ð¼Ð¾Ð´ÐµÐ»Ñ), Ð° Ñ Ð±/Ñ-Ð¼Ð°ÑÐ¾Ðº Ð¸
  // Ð¼Ð¾Ð´ÐµÐ»ÐµÐ¹, Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½ÑÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ¾Ð¼ Ð·Ð´ÐµÑÑ Ð¶Ðµ, ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ° ÐµÑÑ Ð½ÐµÑ â Ð±ÑÐº Ð¾ÑÐ´Ð°ÑÑ
  // ÑÑÑÐµÑÑÐ²ÑÑÑÐ¸Ð¹ Ð¸Ð»Ð¸ Ð·Ð°Ð²Ð¾Ð´Ð¸Ñ Ð½ÐµÐ´Ð¾ÑÑÐ°ÑÑÐ¸Ð¹.
  // ponytail: ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð·Ð°Ð²Ð¾Ð´Ð¸ÑÑÑ ÑÑÐ°Ð·Ñ Ð¿ÑÐ¸ Ð²ÑÐ±Ð¾ÑÐµ Ð¼Ð¾Ð´ÐµÐ»Ð¸, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð±ÑÐ¾ÑÐµÐ½Ð½Ð°Ñ
  // ÑÐ¾ÑÐ¼Ð° Ð¾ÑÑÐ°Ð²Ð»ÑÐµÑ Ð¿ÑÑÑÐ¾Ð¹ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ. Ð Ð²Ð¸ÑÑÐ¸Ð½Ñ Ð¾Ð½ Ð½Ðµ Ð¿Ð¾Ð¿Ð°Ð´Ð°ÐµÑ (ÑÐ°Ð¼ ÑÐ¸Ð»ÑÑÑ Ð¿Ð¾
  // ÑÑÐ¾ÐºÑ), ÑÐ¸ÑÑÐ¸ÑÑ â ÑÐ¾Ð»ÑÐºÐ¾ ÐµÑÐ»Ð¸ ÑÐ°ÐºÐ¸Ðµ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð½Ð°ÑÐ½ÑÑ Ð¼ÐµÑÐ°ÑÑ Ð² /cars/containers.
  const resolveContainerId = async (modelOption, markOption) => {
    if (!markOption?.value || !modelOption?.value) {
      setContainerId(null);
      return null;
    }
    try {
      const res = await ensureContainer({ markId: markOption.value, modelId: modelOption.value });
      const id = res?.data?.id ?? null;
      setContainerId(id);
      return id;
    } catch (e) {
      // ÐÐ¾Ð»ÑÐ° Ð³Ð»Ð¾ÑÐ°ÑÑ Ð½ÐµÐ»ÑÐ·Ñ: Ð±ÐµÐ· ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ° Ð¿ÑÑÑÐµÐµÑ ÑÐ¿Ð¸ÑÐ¾Ðº ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¹ Ð¸
      // Ð¿ÑÐ¾Ð¿Ð°Ð´Ð°ÐµÑ ÐºÐ½Ð¾Ð¿ÐºÐ° Â«ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸ÑÂ» â Ð²ÑÐ³Ð»ÑÐ´Ð¸Ñ ÐºÐ°Ðº ÑÐ»Ð¾Ð¼Ð°Ð½Ð½Ð°Ñ
      // Ð²ÑÑÑÑÐºÐ°, ÑÐ¾ÑÑ Ð½Ð° Ð´ÐµÐ»Ðµ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð» Ð±ÑÐº.
      setContainerId(null);
      alert.error(
        extractErrorMessage(e?.response?.data) ||
          'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð¿Ð¾ Ð¼Ð°ÑÐºÐµ Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ð¸ â ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ñ'
      );
      return null;
    }
  };

  const carInputs = useMemo(
    () =>
      buildCarInfoInputs({
        onMarkChange: () => setContainerId(null),
        onModelChange: resolveContainerId,
        onDcChange: handleDcChange,
        singleDc: true,
        usedDcOnly: true,
        getContainerId: () => containerId,
        withTechPassport: true,
        mileageRequired: true,
        usedDictionaries: true,
      }),
    [containerId]
  );

  const validateCar = (values, resolvedContainerId) => {
    if (values?.vin?.trim()?.length !== 17) {
      alert.error('ÐÐ»Ð¸Ð½Ð° VIN Ð´Ð¾Ð»Ð¶Ð½Ð° Ð±ÑÑÑ 17 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²');
      return false;
    }
    if (values?.issueYear > new Date().getFullYear() || values?.issueYear < 1900) {
      alert.error('ÐÑÐ¾Ð²ÐµÑÑÑÐµ Ð³Ð¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ° Ð°Ð²ÑÐ¾');
      return false;
    }
    if (!resolvedContainerId) {
      alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð¿Ð¾ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¼Ð°ÑÐºÐµ/Ð¼Ð¾Ð´ÐµÐ»Ð¸');
      return false;
    }
    return true;
  };

  const saveCar = async (values, resolvedContainerId) => {
    if (carId) return carId;

    const payload = {
      phid: 5,
      originCarId: CAR_ORIGIN_TYPES.CONSIGNMENT,
      used: true,
      containerId: resolvedContainerId,
      markId: values?.mark?.value,
      modelId: values?.model?.value,
      complectationId: values?.complectationId?.value,
      transmissionId: values?.transmissionId?.value,
      issueYear: values?.issueYear,
      vin: values?.vin?.trim(),
      color: values?.color?.value,
      price: parseInt(String(values?.price).replace(/[^\d]/g, ''), 10),
      engine_volume: values?.engine_volume,
      powerId: values?.power,
      wdId: values?.wdId?.value,
      cityId: values?.cityId?.value,
      dcIds: [].concat(values?.dc || []).map((dc) => dc?.value).filter((v) => v != null),
      mileage: values?.mileage ? parseInt(values.mileage, 10) : undefined,
      engineType: values?.engineType?.value,
      texNumber: values?.texNumber,
      texDate: values?.texDate ? dayjs(values.texDate).format('YYYY-MM-DD') : undefined,
      paid: 5124,
      paidTypeId: 1,
      countryId: 113,
    };

    const data = new FormData();
    data.append('json', JSON.stringify(payload));

    const response = await createCar(data);
    const id = response?.data?.car?.id || response?.data?.id;
    setCarId(id);
    return id;
  };

  const handleSubmit = async () => {
    if (!seller?.value) {
      setSellerError('ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð»Ð¸ ÑÐ¾Ð·Ð´Ð°Ð¹ÑÐµ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°');
      sellerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    setSellerError('');

    const sellerRequisites = await sellerReqFormRef.current.submit();
    if (!sellerRequisites) return;

    const carValues = await carFormRef.current.submit();
    if (!carValues) return;

    // ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¼Ð¾Ð¶ÐµÑ Ð½Ð°Ð¶Ð°ÑÑ Â«Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑÂ» ÑÐ°Ð½ÑÑÐµ, ÑÐµÐ¼ Ð¾ÑÐ²ÐµÑÐ¸Ñ ensureContainer Ð¿Ð¾
    // ÑÐ¾Ð»ÑÐºÐ¾ ÑÑÐ¾ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð¹ Ð¼Ð¾Ð´ÐµÐ»Ð¸ â Ð´Ð¾Ð¶Ð¸Ð¼Ð°ÐµÐ¼ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ Ð·Ð´ÐµÑÑ, Ð° Ð½Ðµ Ð¿Ð°Ð´Ð°ÐµÐ¼ Ð²
    // Â«Ð½Ðµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÑÂ».
    const resolvedContainerId = containerId || (await resolveContainerId(carValues?.model, carValues?.mark));
    if (!validateCar(carValues, resolvedContainerId)) return;

    const requisites = await reqFormRef.current.submit();
    if (!requisites) return;

    setSaving(true);
    try {
      const id = await saveCar(carValues, resolvedContainerId);
      if (!id) throw new Error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ ÑÐ¾Ð·Ð´Ð°ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ');

      await createConsignment({
        carId: id,
        sellerClientId: seller.value,
        price: parseInt(String(carValues?.price).replace(/[^\d]/g, ''), 10),
        requisites,
        sellerRequisites: {
          recipient: sellerRequisites.recipient,
          iban: cleanBank(sellerRequisites.iban),
          bankName: sellerRequisites.bankName,
          bic: cleanBank(sellerRequisites.bic),
        },
      });

      await goToDeal(id);
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || e?.message || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¾ÑÐ¼Ð¸ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ðµ');
    } finally {
      setSaving(false);
    }
  };

  // Ð¡ÑÐ°Ð·Ñ ÑÐ²Ð¾Ð´Ð¸Ð¼ Ð² ÑÐ¾Ð·Ð´Ð°Ð½Ð¸Ðµ ÑÐ´ÐµÐ»ÐºÐ¸ Ñ ÑÑÐ¸Ð¼ Ð°Ð²ÑÐ¾. ÐÐ°ÑÑÐ¾ÑÐºÑ ÑÑÐ½ÐµÐ¼ Ñ Ð±ÑÐºÐ°, ÑÑÐ¾Ð±Ñ
  // ÑÐºÑÐ°Ð½ ÑÐ´ÐµÐ»ÐºÐ¸ Ð¿Ð¾Ð»ÑÑÐ¸Ð» ÑÐ¾Ð²Ð½Ð¾ ÑÐ¾Ñ Ð¶Ðµ Ð¾Ð±ÑÐµÐºÑ, ÑÑÐ¾ Ð¸ Ð¿ÑÐ¸ Ð¿ÑÐ¾Ð´Ð°Ð¶Ðµ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ Ð°Ð²ÑÐ¾.
  const goToDeal = async (id) => {
    const res = await getItems({ id }).catch(() => null);
    const car = res?.data?.cars?.[0];

    if (!car) {
      alert.success('ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¿ÑÐ¸Ð½ÑÑ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ');
      navigate(`/cars/car/${id}/main-data`);
      return;
    }

    navigate('/deals/create', {
      state: {
        car: {
          ...car,
          consignment: car?.consignment || { seller: seller?.client || { name: seller?.label } },
        },
      },
    });
  };

  return (
    <div style={{ paddingBottom: 20 }}>
      {/* Ð¤Ð¾ÑÐ¼Ñ Ð½Ðµ ÑÐ°Ð·Ð¼Ð¾Ð½ÑÐ¸ÑÑÐµÐ¼ Ð½Ð° Ð²ÑÐµÐ¼Ñ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ñ: Ð¿ÑÐ¸ Ð¾ÑÐ¸Ð±ÐºÐµ Ð±ÑÐºÐ° Ð²Ð²ÐµÐ´ÑÐ½Ð½Ð¾Ðµ
          Ð½Ðµ Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð¿ÑÐ¾Ð¿Ð°Ð´Ð°ÑÑ. */}
      {saving && <Loader />}

      {/* ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð¾ÑÑÐ°ÑÑÑÑ Ð½Ð°Ð²ÐµÑÑÑ, Ð³Ð´Ðµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÐµÐ³Ð¾ Ð¸ Ð²ÑÐ±ÑÐ°Ð». */}
      {originInput && <HookForm border inputs={[originInput]} grid={{ display: 'grid', maxWidth: 420 }} />}

      <div className={formStyles.borderWrapper} ref={sellerRef}>
        <p style={textStyles.formTitle}>1. ÐÑÐ¾Ð´Ð°Ð²ÐµÑ</p>
        <div style={{ marginTop: 20 }}>
          <SellerBlock
            seller={seller}
            onChange={(value) => {
              setSeller(value);
              setSellerError('');
              const fio = sellerFio(value);
              if (fio) sellerReqFormRef.current?.setValue('recipient', fio);
            }}
            error={sellerError}
          />
        </div>
      </div>

      <HookForm
        ref={sellerReqFormRef}
        border
        title="2. Ð¡ÑÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°"
        inputs={SELLER_REQUISITES_INPUTS}
        grid={reqGrid}
      />

      <HookForm
        ref={carFormRef}
        border
        title="3. ÐÐ°Ð½Ð½ÑÐµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ"
        inputs={carInputs}
        grid={carGrid}
      />

      {/* Ð¤Ð¾ÑÐ¼Ñ Ð½Ðµ Ð¿Ð¾Ð´Ð¼ÐµÐ½ÑÐµÐ¼ Ð»Ð¾Ð°Ð´ÐµÑÐ¾Ð¼: Ð¾Ð½Ð° Ð´Ð¾Ð»Ð¶Ð½Ð° Ð¾ÑÑÐ°ÑÑÑÑ ÑÐ¼Ð¾Ð½ÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½Ð¾Ð¹, ÑÑÐ¾Ð±Ñ
          Ð¾ÑÐ²ÐµÑ Ð¿Ð¾ ÐÐ¦ Ð±ÑÐ»Ð¾ ÐºÑÐ´Ð° Ð·Ð°Ð¿Ð¸ÑÐ°ÑÑ. ÐÐ¼ÐµÑÑÐ¾ ÑÑÐ¾Ð³Ð¾ Ð³Ð°ÑÐ¸Ð¼ Ð±Ð»Ð¾Ðº Ð¾Ð²ÐµÑÐ»ÐµÐµÐ¼ â
          customDataTop ÑÐµÐ½Ð´ÐµÑÐ¸ÑÑÑ Ð²Ð½ÑÑÑÐ¸ ÐºÐ°ÑÑÐ¾ÑÐºÐ¸, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ inset ÑÑÐ¸ÑÐ°ÐµÑÑÑ Ð¾Ñ Ð½ÐµÑ. */}
      <HookForm
        ref={reqFormRef}
        border
        title={requisitesTitle(viaIntermediary)}
        inputs={REQUISITES_INPUTS}
        grid={reqGrid}
        style={{ position: 'relative' }}
        customDataTop={
          loadingRequisites
            ? () => (
                <div style={reqOverlay}>
                  <LoaderInline />
                </div>
              )
            : undefined
        }
      />

      <Button text="Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÐµÑÐµÐ¹ÑÐ¸ Ðº ÑÐ´ÐµÐ»ÐºÐµ" fill onClick={handleSubmit} disabled={saving} />
    </div>
  );
};

export default ConsignmentCreate;
